import { render, staticRenderFns } from "./Portal.vue?vue&type=template&id=5e851a58&"
import script from "./Portal.vue?vue&type=script&lang=ts&"
export * from "./Portal.vue?vue&type=script&lang=ts&"
import style0 from "./Portal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports